<script setup>
import {computed} from "vue";
import {useBlinking} from "../../../alert-ticker";

const DEFAULT_VARIANT = 'flat'

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    value: {
        type: [String, Number],
        required: true
    },
    badgeContent: {
        type: Number,
        required: true
    },
    baseColor: {
        type: String,
        required: false
    },
    variant: {
        type: String,
        required: false,
        default: DEFAULT_VARIANT
    },
    doAlert: {
        type: Boolean,
        required: false,
        default: false
    }
})
const isBlinkActive = useBlinking(() => props.doAlert);
const baseColor = computed(() => {
    return isBlinkActive.value ? 'red' : props.baseColor;
});
const variant = computed(() => {
    return isBlinkActive.value ? 'flat' : props.variant;
});
</script>

<template>
    <v-tab :value="value" :color="baseColor" :variant="variant">
        {{ label }}
        <template v-slot:append>
            <v-badge
                color="info"
                :content="badgeContent"
                inline
            ></v-badge>
        </template>
    </v-tab>
</template>

